// extracted by mini-css-extract-plugin
export default {"bt":"CopySettings_bt__iahSa","placeHolderShimmer":"CopySettings_placeHolderShimmer__xRt1R"};